module.exports = __webpack_public_path__ + "static/rfh-logo-1d92c3921f4337f20c8437394cdd73e9.png";